const AzureButton = () => {
  const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
  const tenantId = process.env.REACT_APP_AZURE_TENANT_ID;
  const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI;
  const scope = process.env.REACT_APP_AZURE_SCOPE;

  const authorizationEndpoint = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`;

  // Redirect to Azure AD for retrieving authorization code
  const login = () => {
    const authUrl = `${authorizationEndpoint}?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=${scope}&prompt=select_account`;
    window.location.href = authUrl;
  };

  return (
    <>
      <button
        onClick={login}
        style={{
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          width: "100%",
          padding: "12px 14px",
          fontSize: "16px",
          fontWeight: "500",
          color: "#000",
          backgroundColor: "#fff",
          border: "2px solid #e9ecef",
          borderRadius: "10px",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
          transition: "all 0.3s ease",
          minHeight: "48px",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#f3f3f3";
          e.currentTarget.style.borderColor = "#1672DE";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(22, 114, 222, 0.1)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#fff";
          e.currentTarget.style.borderColor = "#e9ecef";
          e.currentTarget.style.boxShadow = "0px 2px 4px rgba(0, 0, 0, 0.1)";
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
          alt="Microsoft Logo"
          style={{ width: "20px", height: "20px" }}
        />
        Sign in with Microsoft
      </button>
      {/* <CommonButton
        handleClick={login}
        sx={{
          width: "50%",
        }}
        size="large"
        className={"signInButton"}
        text="Login with Microsoft"
      /> */}
    </>
  );
};

export default AzureButton;
